import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';

const PdfViewer = () => {
  const [searchParams] = useSearchParams();
  const pdfUrl = searchParams.get('url');
  const propertyName = searchParams.get('property') || 'Property';

  useEffect(() => {
    // Set the document title with property name
    document.title = `Vibrant PropMart - ${propertyName} Brochure`;
  }, [propertyName]);

  if (!pdfUrl) {
    return (
      <Box sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        height: '100vh', gap: 2
      }}>
        <Typography variant="h6" color="error">
          PDF URL not provided
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Please go back and try again.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <iframe src={pdfUrl} style={{  width: '100%',  height: '100%', border: 'none' }} title="Property Brochure" />
    </Box>
  );
};

export default PdfViewer; 